import type { WebSocketMessageData } from '@/types/ws/WebSocketMessageData.ts';
import { logOutAction } from '@/actions/auth/LogOutAction.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';
import { z } from 'zod';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { useWebSocketStore } from '@/stores/WebSocketStore.ts';

const AuthLogInDataSchema = z.object({
    id: z.string(),
    success: z.boolean(),
});

export const authLogInMessageHandler = (messageData: WebSocketMessageData) => {
    const data = AuthLogInDataSchema.parse(messageData);

    if (data.success) {
        return;
    }

    const sessionStore = useSessionStore();
    const webSocketStore = useWebSocketStore();

    if (!sessionStore.isInsideWebView && webSocketStore.connectedClients.length > 1) {
        createTextToast(
            'Desktop app WebSocket session expired',
            'Please log in again',
            'destructive',
            true,
        );
    } else {
        createTextToast('WebSocket session expired', 'Please log in again', 'destructive', false);
    }

    void logOutAction();
};
